export default {
  mounted() {},
};
